import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Page/PageUsage.mdx";

import Examples from "../../Docs/Components/Page/PageExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Page"
            description="Page is a non-visual container that encapsulates providers for child components to consume."
            apiSources={["azure-devops-ui/Components/Page/Page.Props.d.ts"]}
            styleDocGroups={["page"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;